import { icCardActions } from 'modules/ui/icCard';
import { useSelector } from 'react-redux';
import useToastNotification from './useToastNotification';

export async function sleep(msec: any) {
  return new Promise(resolve => setTimeout(resolve, msec));
}

export async function send(device: any, data: any) {
  let uint8a = new Uint8Array(data);
  await device.transferOut(2, uint8a);
  await sleep(10);
}

export async function receive(device: any, len: any) {
  let data = await device.transferIn(1, len);
  await sleep(10);
  let arr = [];
  for (let i = data.data.byteOffset; i < data.data.byteLength; i++) {
    arr.push(data.data.getUint8(i));
  }
  return arr;
}

export async function close(device: any) {
  try {
    device.close();
  } catch (e) {
    console.log(e);
  }
}

export async function session(device: any, dispatch: any, flagAutoPause?: boolean) {
  await send(device, [0x00, 0x00, 0xff, 0x00, 0xff, 0x00]);
  await send(device, [0x00, 0x00, 0xff, 0xff, 0xff, 0x03, 0x00, 0xfd, 0xd6, 0x2a, 0x01, 0xff, 0x00]);
  await receive(device, 6);
  await receive(device, 13);
  await send(device, [0x00, 0x00, 0xff, 0xff, 0xff, 0x03, 0x00, 0xfd, 0xd6, 0x06, 0x00, 0x24, 0x00]);
  await receive(device, 6);
  await receive(device, 13);
  await send(device, [0x00, 0x00, 0xff, 0xff, 0xff, 0x03, 0x00, 0xfd, 0xd6, 0x06, 0x00, 0x24, 0x00]);
  await receive(device, 6);
  await receive(device, 13);
  await send(device, [0x00, 0x00, 0xff, 0xff, 0xff, 0x06, 0x00, 0xfa, 0xd6, 0x00, 0x01, 0x01, 0x0f, 0x01, 0x18, 0x00]);
  await receive(device, 6);
  await receive(device, 13);
  await send(device, [0x00, 0x00, 0xff, 0xff, 0xff, 0x28, 0x00, 0xd8, 0xd6, 0x02, 0x00, 0x18, 0x01, 0x01, 0x02, 0x01, 0x03, 0x00, 0x04, 0x00, 0x05, 0x00, 0x06, 0x00, 0x07, 0x08, 0x08, 0x00, 0x09, 0x00, 0x0a, 0x00, 0x0b, 0x00, 0x0c, 0x00, 0x0e, 0x04, 0x0f, 0x00, 0x10, 0x00, 0x11, 0x00, 0x12, 0x00, 0x13, 0x06, 0x4b, 0x00]);
  await receive(device, 6);
  await receive(device, 13);
  await send(device, [0x00, 0x00, 0xff, 0xff, 0xff, 0x04, 0x00, 0xfc, 0xd6, 0x02, 0x00, 0x18, 0x10, 0x00]);
  await receive(device, 6);
  await receive(device, 13);
  await send(device, [0x00, 0x00, 0xff, 0xff, 0xff, 0x0a, 0x00, 0xf6, 0xd6, 0x04, 0x6e, 0x00, 0x06, 0x00, 0xff, 0xff, 0x01, 0x00, 0xb3, 0x00]);
  await receive(device, 6);
  let idm = (await receive(device, 37)).slice(17, 24);
  if (idm.length > 0) {
    let idmStr = '';
    for (let i = 0; i < idm.length; i++) {
      if (idm[i] < 16) {
        idmStr += '0';
      }
      idmStr += idm[i].toString(16);
    }
    
    if(dispatch){
      dispatch(icCardActions.setIsConnectICCardUsb(true));
      dispatch(icCardActions.setCardId(idmStr));
    }
    if(flagAutoPause){
      dispatch(icCardActions.setDisabledDetect(true));
    }
  } else {
  }
}
const { errorNotification } = useToastNotification();
export async function connectDevice(dispatch: any) {
  let device;
  try {
    if(navigator.usb !== undefined && navigator.usb.requestDevice){
      device = await navigator.usb.requestDevice({ filters: []})
      await device.open(); 
      dispatch(icCardActions.setIsConnectICCardUsb(true));
      dispatch(icCardActions.setDeviceICCard(device));
    }else {
      errorNotification('Pasoriと接続していません');
    }
  } catch (e) {
    dispatch(icCardActions.setIsConnectICCardUsb(false));
    dispatch(icCardActions.setDeviceICCard(null));
    alert(e);
    throw e;
  }
}

export async function detectCard(device: any, dispatch?: any, flagAutoPause?: boolean) {
  try {
    await device.selectConfiguration(1);
    await device.claimInterface(0);

    do {
      await session(device, dispatch, flagAutoPause);
      await sleep(500);
    } while (true);
  } catch (e) {
    dispatch(icCardActions.setIsConnectICCardUsb(false));
    dispatch(icCardActions.setDeviceICCard(null));
    close(device);
    device.close();
    throw e;
  }
}


